import {
  faClockRotateLeft
} from "@fortawesome/free-solid-svg-icons";
import {
  FontAwesomeIcon
} from "@fortawesome/react-fontawesome";
import i18n from "../../../../../../../constants/i18n";
import getKhattabat102GeneralStore from "../../../../../../../stores/khattabat-stores/102-stores/general-102-store";
import { withLiteObserverAndTheme } from "../../../../../../../core/et3-enhanced-render";
import { TGender } from "../../../../../../../Types";

const OneOTwoMessageHistoryButton = withLiteObserverAndTheme<{
  conversationID: string;
  messageId: number;
  isKhattabaMessage: boolean;
  senderGender: TGender;
}>((props) => {
  const { conversationID, messageId, isKhattabaMessage, senderGender, theme } =
    props;
  const { colors } = theme;
  const backgroundColor = isKhattabaMessage
    ? colors.all.paleBluishGray
    : senderGender === "m"
      ? colors.all.bondiBlue
      : colors.all.vibrantPinkishMagenta;

  return (
    <button
      type="button"
      title={i18n.get(
        "KHATTABAT_ONE_O_TWO_MESSAGE_HISTORY_BUTTON"
      )}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();

        getKhattabat102GeneralStore()
          .openMessageHistoriesPopUp({
            conversationID,
            messageId
          });
      }}
      style={{
        width: 36,
        height: 34,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 0,
        margin: 0,
        border: "none",
        borderRadius: 9,
        backgroundColor,
        cursor: "pointer",
        boxSizing: "border-box",
        pointerEvents: "auto"
      }}
    >
      <FontAwesomeIcon
        icon={faClockRotateLeft}
        size="sm"
        color={colors.all.white}
        style={{
          pointerEvents: "none"
        }}
      />
    </button>
  );
})

export default OneOTwoMessageHistoryButton;